// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "consent_form_template".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "consent_form_template" table (1:1 with a DB row, on the wire). */
export const consentFormTemplateAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    title: z.string(),
    externalUrl: z.string().nullable(),
    body: z.string(),
    fields: z.unknown(),
    requiresSignature: z.boolean(),
    isActive: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=consentFormTemplate.js.map